<template>
  <div class="survey-page bg-survey-begin text-gray03">
    <transition
      name="custom-classes-transition"
      enter-active-class="animated fadeInDown"
    >
      <div
        class="card text-center card-survey-begin"
        :class="{ 'card-survey-unauthorized': isUnauthorizedRoute }"
      >
        <section v-if="isLoading" class="loading">
          <loading />
          <h3>{{ labels.loading }}</h3>
          <h3>{{ labels.description }}</h3>
        </section>
        <transition name="component-fade" mode="out-in" v-else>
          <survey-begin-unauthorized
            v-if="isUnauthorizedRoute"
            :nextSurveyDate="nextSurveyDate"
          />
          <survey-begin-start v-else />
        </transition>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import SurveyBeginStart from '@/components/CustomSurveys/Survey/Begin/SurveyBeginStart.vue'
import SurveyBeginUnauthorized from '@/components/CustomSurveys/Survey/Begin/SurveyBeginUnauthorized.vue'
import { pathOr, path } from 'ramda'
import Loading from '@/components/Shared/Loading.vue'

export default {
  components: {
    SurveyBeginStart,
    SurveyBeginUnauthorized,
    Loading,
  },
  data() {
    return {
      isLoading: true,
    }
  },
  computed: {
    ...mapGetters({
      resources: 'resources',
    }),
    labels() {
      return this.resources.page.customSurveys.survey
    },
    isUnauthorizedRoute() {
      return this.type === 'unauthorized'
    },
    nextSurveyDate() {
      return path(['params', 'nextSurveyDate'], this.$route)
    },
    type() {
      return pathOr('begin', ['params', 'type'], this.$route)
    },
    isFromEngagementSurvey() {
      return this.$route.query.origin === 'engagement-survey'
    },
  },
  async mounted() {
    if (!this.isFromEngagementSurvey) {
      await this.$store.dispatch(
        'customSurvey/getSurvey',
        this.$route.params.id
      )
    }
    this.isLoading = false
  },
}
</script>

<style scoped lang="scss">
@import '~@/styles/custom/colors';
@import '~bootstrap/scss/_functions';
@import '~bootstrap/scss/_variables';
@import '~bootstrap/scss/mixins/breakpoints';

$img-height-sm: 14vh;
$img-height: 200px;

.survey-page {
  display: flex;
  justify-content: center;
  left: 0;
  min-height: 100%;
  overflow: auto;
  padding: 7rem 0;
  position: absolute;
  right: 0;
  top: 0;

  @media (max-height: 800px) {
    padding: 7rem 0 2rem 0;
  }

  @media (max-width: 425px) {
    padding: 3rem 0;
  }

  .card-survey-begin {
    display: flex;
    justify-content: center;
    padding: calc(#{$img-height-sm} * 0.7) 20px calc(#{$img-height-sm} * 0.5);
    width: 80%;

    @include media-breakpoint-up(sm) {
      height: 100vh;
      min-height: max-content;
      max-height: 515px;
      padding-bottom: 0;
      width: 60%;
    }

    @include media-breakpoint-up(lg) {
      padding-top: calc(#{$img-height} * 0.55);
    }

    ::v-deep .survey__begin__title {
      font-size: 1.2em;
      color: map-get($theme-colors, 'primary');

      @include media-breakpoint-up(lg) {
        font-size: 3em;
      }
    }

    ::v-deep .survey__begin__description {
      font-size: 0.9em;

      @include media-breakpoint-up(lg) {
        font-size: 1.5em;
      }
    }

    ::v-deep .survey__begin__start {
      .survey__begin__title,
      .survey__begin__description {
        margin-bottom: 0.7em;
      }
    }

    .loading {
      font-size: 1.2em;
      color: map-get($theme-colors, 'primary');
    }
  }

  .card-survey-begin:not(.card-survey-unauthorized)::before {
    content: ' ';
    width: 100%;
    height: $img-height-sm;
    background-image: url(/survey/icon_survey.svg);
    position: absolute;
    background-position: center;
    text-align: center;
    background-repeat: no-repeat;
    left: 0;
    background-size: contain;
    top: calc(#{$img-height-sm} / 2 * -1);

    @include media-breakpoint-up(lg) {
      height: $img-height;
      top: calc(#{$img-height} / 2 * -1);
    }
  }

  .card-survey-unauthorized::before {
    content: ' ';
    width: 100%;
    height: $img-height-sm;
    background-image: url(/survey/icon_survey_unauthorized.png);
    position: absolute;
    background-position: center;
    text-align: center;
    background-repeat: no-repeat;
    left: 0;
    background-size: contain;
    top: calc(#{$img-height-sm} / 2 * -1);

    @include media-breakpoint-up(lg) {
      height: $img-height;
      top: calc(#{$img-height} / 2 * -1);
    }
  }
}

@include media-breakpoint-up(lg) {
  .component-fade-enter-active,
  .component-fade-leave-active {
    transition: opacity 0.3s ease;
  }
  .component-fade-enter, .component-fade-leave-to
  /* .component-fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
}
</style>
